import { computed } from 'vue'
import telegram from '@/assets/images/footer/telegram.svg'
import medium from '@/assets/images/footer/medium.svg'
import linkedin from '@/assets/images/footer/linkedin.svg'
import facebook from '@/assets/images/footer/facebook.svg'
import x from '@/assets/images/footer/x.svg'
import tiktok from '@/assets/images/footer/tiktok.svg'

export function useSocials() {
  return [
    {
      icon: telegram,
      // href: '',
      href: 'https://t.me/TantinTTx',
      class: 'social-icon-telegram',
    },
    // {
    //   icon: medium,
    //   href: '',
    //   class: 'social-icon-medium',
    // },
    // {
    //   icon: linkedin,
    //   href: '',
    //   class: 'social-icon-linkedin',
    // },
    // {
    //   icon: facebook,
    //   href: '',
    //   class: 'social-icon-facebook',
    // },
    {
      icon: x,
      // href: '',
      href: 'https://x.com/TantinGroup',
      class: 'social-icon-x',
    },
    // {
    //   icon: tiktok,
    //   href: '',
    //   class: 'social-icon-tiktok',
    // },
  ]
}

export function useFooterLinks({ t, localePath }) {
  return [
    {
      label: t('关于我们'),
      target: '_blank',
      rel: 'nofollow',
      list: [
        {
          label: t('关于我们'),
          href: `${t('zendesk')}/articles/45858475627545-About-Us`,
        },
        {
          label: t('受禁国家/地区'),
          href: `${t('zendesk')}/articles/46059037795097`,
        },
        {
          label: t('TT团队'),
          href: `${t('zendesk')}/articles/45858620466841-TT-Team`,
        },
        {
          label: t('联系我们'),
          href: '',
        },
        {
          label: t('公告中心'),
          href: `${t('zendesk')}/categories/45263325183513-Announcement-Center`,
        },
        {
          label: t('帮助中心'),
          href: `${t('zendesk')}`,
        },
        {
          label: t('友情链接'),
          href: localePath(`/links`),
        },
        {
          label: t('提交反馈'),
          href: '',
        },
        {
          label: t('隐私协议'),
          href: localePath(`/privacy-portal`),
        },
        {
          label: t('用户协议'),
          href: localePath(`/terms`),
        },
      ],
    },
    {
      label: t('买币'),
      target: '_blank',
      rel: 'nofollow',
      list: [
        {
          label: t('买BTC'),
          href: localePath('/spot/BTCUSDT'),
        },
        {
          label: t('买ETH'),
          href: localePath('/spot/ETHUSDT'),
        },
        {
          label: t('买Doge'),
          href: localePath('/spot/DOGEUSDT'),
        },
        {
          label: t('买SOL'),
          href: localePath('/spot/SOLUSDT'),
        },
        {
          label: t('买XRP'),
          href: localePath('/spot/XRPUSDT'),
        },
        {
          label: t('买SHIB'),
          href: localePath('/spot/SHIBUSDT'),
        },
        {
          label: t('加密货币行情'),
          href: localePath('/markets/spot'),
        },
        {
          label: t('比特币价格'),
          href: localePath('/spot/BTCUSDT'),
        },
        {
          label: t('以太坊价格'),
          href: localePath('/spot/ETHUSDT'),
        },
      ],
    },
    {
      label: t('产品'),
      list: [
        {
          label: t('行情'),
          href: localePath('/markets/spot'),
        },
        {
          label: t('现货'),
          href: localePath('/spot'),
        },
        {
          label: t('空投'),
          href: localePath('/airdrop'),
        },
        {
          label: t('合约'),
          href: '',
        },
        {
          label: t('理财'),
          href: '',
        },
        {
          label: t('跟单'),
          href: '',
        },
        {
          label: t('打新'),
          href: '',
        },
      ],
    },
    {
      label: t('服务'),
      list: [
        {
          label: t('官方验证通道'),
          email: '',
          href: '',
        },
        // {
        //   label: t('上币申请'),
        //   email: '',
        //   href: '',
        // },
        {
          label: t('合伙人'),
          email: '',
          href: '',
        },
        {
          label: t('好友邀请'),
          email: '',
          href: '',
        },
        {
          label: t('VIP服务'),
          email: '',
          href: '',
        },
        {
          label: t('机构服务'),
          email: '',
          href: '',
        },
        {
          label: t('费率表'),
          email: '',
          href: '',
        },
      ],
    },
    {
      label: t('工具'),
      target: '_blank',
      rel: 'nofollow',
      list: [
        {
          label: t('币圈百科'),
          href: '',
        },
        {
          label: t('币种介绍'),
          href: '',
        },
        {
          label: t('加密货币术语表'),
          href: '',
        },
      ],
    },
  ]
}

export function useNav({ t, localePath }) {
  return computed(() => [
    { label: t('行情'), href: localePath('/markets/spot') },
    { label: t('现货'), href: localePath('/spot/BTCUSDT') },
    { label: t('空投'), href: localePath('/airdrop'), tag: true },
    { label: t('合约'), href: localePath('/futures') },
    { label: t('理财'), href: ``, isOpen: false },
    { label: t('跟单'), href: ``, isOpen: false },
    { label: t('打新'), href: ``, isOpen: false },
  ])
}

export const appDownLoadUrl = {
  IOS: 'https://apps.apple.com/us/app/tt-exchange-buy-btc-eth/id6744518018?l=zh-Hans-CN',
  Google: '',
  APK: 'https://download.ttx.vip/android/release(20250429_1901)-TTExchangeApp-v1.0.5.apk',
}

// 国内线路

export function domesticLink({ t }) {
  return [{
    name: t('国内'),
    url: 'https://download.ttx.vip/ios/plist/20250430-031108-102-Inhouse-alone-local-0.plist',
  }, {
    name: t('国内'),
    url: 'https://download.ttx.vip/ios/plist/20250429-233713-102-Inhouse-share-local-0.plist',
  }, {
    name: t('国内'),
    url: 'https://download.ttx.vip/ios/plist/20250430-031132-102-Inhouse-alone-local-1.plist',
  }, {
    name: t('国内'),
    url: 'https://download.ttx.vip/ios/plist/20250430-031152-102-Inhouse-alone-local-2.plist',
  }, {
    name: t('国内'),
    url: 'https://download.ttx.vip/ios/plist/20250430-031212-102-Inhouse-alone-local-3.plist',
  }, {
    name: t('国内'),
    url: 'https://download.ttx.vip/ios/plist/20250430-031239-102-Inhouse-alone-local-4.plist',
  }, {
    name: t('国内'),
    url: 'https://download.ttx.vip/ios/plist/20250430-031301-102-Inhouse-alone-local-5.plist',
  }]
}

export function overseasLink({ t }) {
  return [{
    name: t('海外'),
    url: 'https://download.ttx.vip/ios/plist/20250430-031402-102-Inhouse-alone-overseas-0.plist',
  }, {
    name: t('海外'),
    url: 'https://download.ttx.vip/ios/plist/20250430-031427-102-Inhouse-alone-overseas-1.plist',
  }, {
    name: t('海外'),
    url: 'https://download.ttx.vip/ios/plist/20250430-031449-102-Inhouse-alone-overseas-2.plist',
  }, {
    name: t('海外'),
    url: 'https://download.ttx.vip/ios/plist/20250430-031510-102-Inhouse-alone-overseas-3.plist',
  }]
}
